import type { MenuItem } from '@/entities/layout';

import { MENU_ITEM_MANUAL_NODES } from '../model/constants';
import type { NavigationItem } from '../model/types';

/**
 * Converts a backend menu item to a navigation item, assigning the manual
 * help id by item code (recursively for sub-items).
 */
export const toNavigationItem = (item: MenuItem): NavigationItem => ({
  ...item,
  helpContentId: MENU_ITEM_MANUAL_NODES[item.code] ?? null,
  subItems: item.subItems?.map(toNavigationItem)
});
